<template>
  <a-modal v-model:visible="modal.show" :footer="null"
           wrapClassName="modal_downloadIFP" destroyOnClose>
    <a-row type="flex" justify="space-between">
      <a-col>
        <div class="text">
          <span>InfraPilot-community-server 软件包</span><br>
          获取 InfraPilot 一键安装离线包
        </div>
      </a-col>
      <a-col flex="100px">
        <a v-if="modal.href"
           class="button_n_3" target="_blank"
           :href="modal.href">
          立即下载
        </a>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

import {
  LicenseTypeEnum,
  RequestGetDownloadIFP, ResponseGetDownloadIFP, AxiosGetDownloadIFP
} from '@server/apiLicense';

export default {
  name: 'page_modalVideo',
  data(): DataInterface {
    return {
      request: {
        intercept: {
          download: false
        }
      },
      form: {
        data: {
          name: 'infra-pilot',
          category: LicenseTypeEnum.Free,
          version: 'v1.0.0'
        }
      },
      modal: {
        show: false,
        href: ''
      }
    };
  },
  methods: {
    /**
     * 开启
     */
    open(): void {
      if (!$RQ.SSO.check()) {
        $RQ.SSO.login();
        return;
      }
      
      this.modal.show = true;
      this.getLicenseInfo();
    },
    
    /**
     * 关闭
     */
    close(): void {
      this.modal.show = false;
      this.modal.href = '';
    },
    
    async getLicenseInfo(): Promise<any> {
      if (this.request.intercept.download) return;
      this.request.intercept.download = true;
      
      await AxiosGetDownloadIFP({
        product_name: this.form.data.name,
        product_category: this.form.data.category,
        product_release_version: this.form.data.version
      } as RequestGetDownloadIFP)
        .then((response: any) => {
          const data: ResponseGetDownloadIFP = response.data;
          
          if (data.code !== $Enum.CodeEnum.Normal) return;
          
          this.modal.href = data.data;
        })
        .finally(() => {
          this.request.intercept.download = false;
        });
    },
  }
}
</script>

<style lang="less" rel="stylesheet/less">
@import '@resource/css/_global.less';

@image: '@{src_image}';

.modal_downloadIFP {
  .ant-modal {
    width: 450px !important;
    
    .ant-modal-body {
      .text {
        .font(left, @font_5, @color_13, @font_7);
        
        span {
          font-weight: bold;
        }
      }
      
      .button_n_3 {
        width: auto !important;
      }
    }
    
    .ant-modal-close {
      right: -40px;
      width: 30px;
      height: 30px;
      color: @color_black;
      background-color: fade(@color_white, 80);
      .transition(background-color @time);
      
      &:hover {
        background-color: fade(@color_white, 100);
      }
      
      .ant-modal-close-x {
        position: relative;
        width: 100%;
        height: 100%;
        
        .ant-modal-close-icon {
          .position();
          width: 16px;
          height: 16px;
          margin: auto;
        }
      }
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .modal_downloadIFP {
    .ant-modal {
      .ant-modal-close {
        .position(bottom, -40px);
        margin: 0 auto;
      }
    }
  }
}
</style>